import InspectorActions from './InspectorActions';
import { InspectorAction, InspectorActionsProps } from './InspectorActions.model';

export default InspectorActions;
export type { InspectorActionsProps, InspectorAction };
